import "./main.css"

interface IIndisponible {
   debut: Date,
   fin  : Date
}

interface IPause {
   jour : number,
   debut: number,
   fin  : number
}

declare global {
   const sn33_rdv_indisponibles: IIndisponible[];
   const sn33_rdv_ouverture    : number;
   const sn33_rdv_fermeture    : number;
   const sn33_rdv_pauses       : IPause[];
}

interface RequestData {
   [key: string]: boolean | number | string
};

declare const sn33_rdv_intervalle = 1.00;

class Sn33Rdv {

   private id                = 0;
   private display_step      = 0;
   private display_day       = '';
   private display_datetime  = '';  // ISO 8601 format
   private readonly aujourd_hui       = new Date();
   private readonly div_description   : HTMLDivElement;
   private readonly div_tarif         : HTMLDivElement;
   private readonly btn_prev          : HTMLButtonElement;
   private readonly btn_next          : HTMLButtonElement;
   private readonly span_month_year   : HTMLSpanElement;
   private readonly p_jour            : HTMLParagraphElement;
   private readonly div_horaires      : HTMLDivElement;
   private readonly p_message_d_erreur: HTMLParagraphElement;
   private readonly span_prestation   : HTMLSpanElement;
   private readonly span_date         : HTMLSpanElement;
   private readonly span_heure        : HTMLSpanElement;
   private readonly div_steps         : HTMLDivElement[] = [];
   private readonly sel_service       : HTMLSelectElement;
   private readonly inp_prenom        : HTMLInputElement;
   private readonly inp_nom           : HTMLInputElement;
   private readonly inp_email         : HTMLInputElement;
   private readonly inp_tel           : HTMLInputElement;
   private readonly inp_notes         : HTMLInputElement;
   private readonly inp_a_notifier    : HTMLInputElement;

   private duration = 0.0;
   private year     = this.aujourd_hui.getFullYear();
   private month    = this.aujourd_hui.getMonth();
   private day      = this.aujourd_hui.getDate();

   private static qs<T>(selector: string): T {
      const t: T = document.querySelector(selector) as T;
      if( t === undefined ) {
         throw new Error(`${selector} is not a valid selector!`);
      }
      return t;
   }

   private static qe<T>(id: string): T {
      const t: T = document.getElementById(id) as T;
      if( t === undefined ) {
         throw new Error(`${id} is not a valid id!`);
      }
      return t;
   }

   public constructor(id: number) {
      this.id = id;
      this.div_description    = Sn33Rdv.qs(`#sn33-rdv-container-${this.id} div.sn33-rdv-description-du-service`);
      this.div_tarif          = Sn33Rdv.qs(`#sn33-rdv-container-${this.id} div.sn33-rdv-tarif-du-service`);
      this.btn_prev           = Sn33Rdv.qs(`#sn33-rdv-container-${this.id} button.sn33-rdv-previous`);
      this.btn_next           = Sn33Rdv.qs(`#sn33-rdv-container-${this.id} button.sn33-rdv-next`);
      this.span_month_year    = Sn33Rdv.qs(`#sn33-rdv-container-${this.id} span.sn33-rdv-month-year`);
      this.p_jour             = Sn33Rdv.qs(`#sn33-rdv-container-${this.id} p.sn33-rdv-jour`);
      this.div_horaires       = Sn33Rdv.qs(`#sn33-rdv-container-${this.id} div.sn33-rdv-horaires`);
      this.p_message_d_erreur = Sn33Rdv.qs(`#sn33-rdv-container-${this.id} p.sn33-rdv-message-d-erreur`);
      this.span_prestation    = Sn33Rdv.qs(`#sn33-rdv-container-${this.id} span.sn33-rdv-prestation`);
      this.span_date          = Sn33Rdv.qs(`#sn33-rdv-container-${this.id} span.sn33-rdv-date`);
      this.span_heure         = Sn33Rdv.qs(`#sn33-rdv-container-${this.id} span.sn33-rdv-heure`);
      this.div_steps.push     ( Sn33Rdv.qs(`#sn33-rdv-container-${this.id} div.sn33-rdv-step-0`));
      this.div_steps.push     ( Sn33Rdv.qs(`#sn33-rdv-container-${this.id} div.sn33-rdv-step-1`));
      this.div_steps.push     ( Sn33Rdv.qs(`#sn33-rdv-container-${this.id} div.sn33-rdv-step-2`));
      this.div_steps.push     ( Sn33Rdv.qs(`#sn33-rdv-container-${this.id} div.sn33-rdv-step-3`));
      this.sel_service        = Sn33Rdv.qe(`sn33-rdv-service-${this.id}`);
      this.inp_prenom         = Sn33Rdv.qe(`sn33-rdv-prenom-${this.id}`);
      this.inp_nom            = Sn33Rdv.qe(`sn33-rdv-nom-${this.id}`);
      this.inp_email          = Sn33Rdv.qe(`sn33-rdv-email-${this.id}`);
      this.inp_tel            = Sn33Rdv.qe(`sn33-rdv-tel-${this.id}`);
      this.inp_notes          = Sn33Rdv.qe(`sn33-rdv-notes-${this.id}`);
      this.inp_a_notifier     = Sn33Rdv.qe(`sn33-rdv-a-notifier-${this.id}`);
      this.inp_prenom .addEventListener('change', () => this.check_form());
      this.inp_nom    .addEventListener('change', () => this.check_form());
      this.inp_tel    .addEventListener('change', () => this.check_form());
      this.inp_email  .addEventListener('change', () => this.check_form());
      this.sel_service.addEventListener('change', () => this.renseigne_la_description_du_service());
      const previous_month: HTMLButtonElement = Sn33Rdv.qe(`sn33-rdv-previous-month-${id}`);
      const next_month    : HTMLButtonElement = Sn33Rdv.qe(`sn33-rdv-next-month-${id}`);
      previous_month.addEventListener('click', () => this.previous_month());
      next_month    .addEventListener('click', () => this.next_month());
      this.btn_prev .addEventListener('click', () => this.previous());
      this.btn_next .addEventListener('click', () => this.next());
      this.display();
   }

   private renseigne_la_description_du_service(): void {
      if(this.sel_service.value === 'None') {
         this.div_description.innerText = '';
         this.div_tarif      .innerText = '';
         this.btn_next.disabled = true;
      }
      else {
         const service = this.sel_service.options[this.sel_service.selectedIndex];
         this.div_description.innerText = service.dataset.description ?? '';
         this.div_tarif      .innerText = `${service.dataset.tarif} €`;
         this.btn_next.disabled = false;
      }
   }

   private est_disponible(pauses: IPause[], iso_day: string, heure_debut: number, heure_fin: number): boolean {
      for( const pause of pauses ) {
         if(  (( heure_debut > pause.debut )&&( heure_debut < pause.fin ))
            ||(( heure_fin   > pause.debut )&&( heure_fin   < pause.fin )))
         {
            return false;
         }
      }
      const date_debut = new Date( iso_day + 'T' + this.minute_to_hh_mm( heure_debut ));
      const date_fin   = new Date( iso_day + 'T' + this.minute_to_hh_mm( heure_fin ));
      for( const indisponible of sn33_rdv_indisponibles ) {
         if(  (( date_debut >= indisponible.debut )&&( date_debut <= indisponible.fin ))
            ||(( date_fin   >= indisponible.debut )&&( date_fin   <= indisponible.fin )))
         {
            return false;
         }
      }
      return true;
   }

   private dernier_jour_du_mois(year: number, month: number): number {
      const d = new Date();
      d.setFullYear( year, month+1, 0 );
      return d.getDate();
   }

   private build_iso_day(year: number, month: number, day: number): string {
      return year.toString() + '-' + month.toString().padStart(2,'0') + '-' + day.toString().padStart(2,'0');
   }

   private il_existe_au_moins_un_creneau_disponible_le(year: number, month: number, day: number): boolean {
      const iso_day = this.build_iso_day( year, month + 1, day );
      const date    = new Date( iso_day );
      if( date < this.aujourd_hui ) {
         return false;
      }
      const day_of_week = date.getDay();
      const pauses      = [];
      for( const pause of sn33_rdv_pauses ) {
         if( pause.jour == day_of_week ) {
            pauses.push(pause);
         }
      }
      let debut = sn33_rdv_ouverture;
      let fin   = debut + this.duration;
      while( fin < sn33_rdv_fermeture ) {
         if( this.est_disponible( pauses, iso_day, debut, fin )) {
            return true;
         }
         debut += sn33_rdv_intervalle;
         fin   += sn33_rdv_intervalle;
      }
      return false;
   }

   private cherche_la_premiere_disponibilite(): boolean {
      let first_month = this.month;
      let first_day   = this.day;
      for( let year = this.year; year < this.year + 2; ++year ) {
         for( let month = first_month; month < 12; ++month ) {
            const last_day = this.dernier_jour_du_mois( year, month );
            for( let day = first_day; day < last_day; ++day ) {
               if( this.il_existe_au_moins_un_creneau_disponible_le( year, month, day )) {
                  this.year  = year;
                  this.month = month;
                  this.day   = day;
                  return true;
               }
            }
            first_day = 1;
         }
         first_month = 0;
      }
      return false;
   }

   fill_dates() {
      this.cherche_la_premiere_disponibilite();
      const iso_day = this.build_iso_day( this.year, this.month + 1, 1 );
      const d = new Date( iso_day );
      const current_month = this.month;
      const text = d.toLocaleDateString('default', { month: 'long' }) + ' ' + this.year;
      this.span_month_year.innerText = text[0].toUpperCase() + text.substring(1);
      const tds = document.querySelectorAll(`#sn33-rdv-container-${this.id} div.sn33-rdv-dates td`);
      let day_of_week = d.getDay();
      let dow         = 1; // lundi
      for( const td of tds ) {
         td.textContent = '';
         if( dow == day_of_week ) {
            if( d.getMonth() == current_month ) {
               const day = d.getDate();
               if( day >= this.day ) {
                  const year  = d.getFullYear();
                  const month = d.getMonth();
                  if( this.il_existe_au_moins_un_creneau_disponible_le(year, month, day)) {
                     const ts = this.build_iso_day( year, month + 1, day );
                     const button = document.createElement('button');
                     button.innerText = day.toString();
                     if( this.display_day == ts ) {
                        button.style.backgroundColor = 'lightgreen';
                     }
                     button.addEventListener('click', () => this.display_times(button, ts));
                     td.appendChild(button);
                  }
               }
               else {
                  td.innerHTML = d.getDate().toString();
               }
            }
            d.setDate( d.getDate() + 1 );
            day_of_week = d.getDay();
         }
         else {
            td.innerHTML = '&nbsp;';
         }
         dow = ++dow % 7; /* eslint no-useless-assignment: "off" */
      }
   }

   private send_post_request(url: string, data?: RequestData, cb?: (status: boolean) => void): void {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', url, true );
      xhr.withCredentials = true;
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      xhr.responseType = 'json';
      xhr.onreadystatechange = function () {
         if( xhr.readyState === 4 ) {
            if( cb ) {
               let response = null;
               if( xhr.status === 200 ) {
                  response = xhr.response;
               }
               cb(response ? response.status : true);
            }
         }
      };
      if( data ) {
         const encoded =
            Object.keys( data )
               .map( key => `${encodeURIComponent( key )}=${encodeURIComponent( data[ key ])}`)
               .join('&');
         xhr.send( encoded );
      }
      else {
         xhr.send();
      }
   }

   private display(): void {
      const prenom = this.inp_prenom.value.trim();
      const nom    = this.inp_nom   .value.trim();
      const tel    = this.inp_tel   .value.trim();
      this.btn_prev.disabled = ( this.display_step == 0 )||( this.display_step == 3 );
      this.btn_next.disabled =
           (( this.display_step === 0 )&&( this.sel_service.value === "None"))
         ||(( this.display_step === 1 )&&( this.display_datetime  === ""    ))
         ||(( this.display_step === 2 )&&(
              ( prenom === "" )
            ||( nom    === "" )
            ||( tel    === "" )))
         ||( this.display_step === 3 );
      const items = document.querySelectorAll(`#sn33-rdv-container-${this.id} div.sn33-rdv-steps > div`);
      for( let i = 0; i < items.length; ++i ) {
         if( i == this.display_step ) {
            items[i].classList.add('sn33-rdv-step-done');
            this.div_steps[i].style.display = 'block';
         }
         else if( i <= this.display_step ) {
            items[i].classList.add('sn33-rdv-step-done');
            this.div_steps[i].style.display = 'none';
         }
         else {
            items[i].classList.remove('sn33-rdv-step-done');
            this.div_steps[i].style.display = 'none';
         }
      }
      const prestation = this.sel_service.options[this.sel_service.selectedIndex];
      this.duration = parseFloat( prestation.dataset.duree ?? '0' ) / 60.0;
      this.span_prestation.textContent = this.sel_service.value;
      if( this.display_step === 1 ) {
         this.year  = this.aujourd_hui.getFullYear();
         this.month = this.aujourd_hui.getMonth();
         this.day   = this.aujourd_hui.getDate();
         this.fill_dates();
      }
      else if( this.display_step === 3 ) {
         const client = {
            'prenom'     : prenom,
            'nom'        : nom,
            'tel'        : tel,
            'email'      : this.inp_email.value,
            'adresse'    : '',
            'liste_rouge': 'false',
            'email_error': 'false',
            'notes'      : this.inp_notes.value
         }
         this.send_post_request('/rendez-vous/clients/create', client,
            () => {
               const duree = this.sel_service.options[this.sel_service.selectedIndex].dataset.duree ?? "60";
               const rdv = {
                  'date'      : this.display_datetime,
                  'prenom'    : prenom,
                  'nom'       : nom,
                  'prestation': this.sel_service.value,
                  'duree'     : duree,
                  'a_notifier': this.inp_a_notifier.checked,
                  'confirme'  : 0,
                  'notes'     : this.inp_notes.value
               };
               this.send_post_request('/rendez-vous/agenda/create', rdv,
                  (status: boolean) => {
                     if( status ) {
                        const prise_de_rdv = {
                           'key_date': this.display_datetime
                        };
                        this.send_post_request('/rendez-vous/messages/prise-de-rendez-vous', prise_de_rdv );
                     }
                     else {
                        alert("Un autre client a pris le rendez-vous que vous avez sélectionné entre temps, veuillez recommencer, s'il vous plaît.");
                        location.reload();
                     }
                  }
               )
            }
         );
      }
   }

   private previous(): void {
      if( --this.display_step < 0 ) {
         this.display_step = 0;
         return;
      }
      this.display();
   }

   private next(): void {
      if( ++this.display_step > 3 ) {
         this.display_step = 3;
         return;
      }
      this.display();
   }

   private previous_month(): void {
      if( --this.month < 0 ) {
         this.month = 11;
         --this.year;
      }
      this.day = 1;
      const date = new Date(this.year, this.month, this.day);
      if( date < this.aujourd_hui ) {
         this.year  = this.aujourd_hui.getFullYear();
         this.month = this.aujourd_hui.getMonth();
         this.day   = this.aujourd_hui.getDate();
      }
      this.fill_dates();
   }

   private next_month(): void {
      if( ++this.month > 11 ) {
         this.month = 0;
         ++this.year;
      }
      this.day = 1;
      this.fill_dates();
   }

   private minute_to_hh_mm(heure: number): string {
      const h = Math.floor( heure );
      const m = ( 60.0 * ( heure - h )).toFixed(0);
      if( m.length < 2 ) {
         return h + ':0' + m;
      }
      return h + ':' + m;
   }

   private display_times(selected_button: HTMLButtonElement, day: string): void {
      const buttons = document.querySelectorAll(`#sn33-rdv-container-${this.id} div.sn33-rdv-dates table > tbody td button`);
      for( const button of buttons ) {
         (button as HTMLButtonElement).style.backgroundColor = this.btn_next.style.backgroundColor;
      }
      selected_button.style.backgroundColor = "lightgreen";
      this.display_day = day;
      const options = {
         weekday: "long",
         month  : "long",
         day    : "numeric",
         year   : "numeric",
      } as const;
      this.p_jour.textContent = new Date( day ).toLocaleDateString( "fr-FR", options );
      this.p_jour.textContent = this.p_jour.textContent[0].toUpperCase() + this.p_jour.textContent.substring(1);
      this.div_horaires.innerHTML = '';
      const day_of_week = new Date( day ).getDay();
      const pauses = [];
      for( const pause of sn33_rdv_pauses ) {
         if( pause.jour == day_of_week ) {
            pauses.push(pause);
         }
      }
      let debut = sn33_rdv_ouverture;
      let fin   = debut + this.duration;
      while( fin < sn33_rdv_fermeture ) {
         if( this.est_disponible( pauses, day, debut, fin )) {
            const button  = document.createElement('button');
            const hour    = Math.floor( debut );
            const mm      = 60.0 * ( debut - Math.floor( debut ));
            const minutes = Math.round( mm );
            const minStr  = (( minutes < 10 ) ? '0' : '') + minutes;
            button.onclick = () => this.choisir_une_heure( button, hour + ':' + minStr );
            button.innerText = hour + ' h ' + minStr;
            this.div_horaires.appendChild( button );
         }
         debut += sn33_rdv_intervalle;
         fin   += sn33_rdv_intervalle;
      }
   }

   private choisir_une_heure(button: HTMLButtonElement, time:string): void {
      const buttons = document.querySelectorAll("#sn33-rdv-heures button")
      for( const button of buttons ) {
         (button as HTMLButtonElement).style.backgroundColor = this.btn_next.style.backgroundColor;
      }
      button.style.backgroundColor = "lightgreen";
      this.display_datetime = this.display_day + 'T' + time + ':00';
      this.span_date .textContent = this.p_jour.textContent;
      this.span_heure.textContent = time;
      this.div_tarif .textContent = this.sel_service.options[this.sel_service.selectedIndex].dataset.tarif ?? '';
      this.btn_next.disabled = false;
   }

   private check_form(): void {
      const prenom = this.inp_prenom.value.trim();
      const nom    = this.inp_nom   .value.trim();
      const tel    = this.inp_tel   .value.trim();
      const nom_ou_prenom_manquant = ( prenom === '' )||( nom === '' );
      const tel_manquant = ( tel === '' );
      this.btn_next.disabled = nom_ou_prenom_manquant || tel_manquant;
      if( nom_ou_prenom_manquant ) {
         this.p_message_d_erreur.textContent = "Le nom et le prénom sont obligatoires.";
      }
      else if( tel_manquant ) {
         this.p_message_d_erreur.textContent = "Un téléphone est indispensable pour vous contacter, l'e-mail est bienvenu.";
      }
      else {
         this.p_message_d_erreur.textContent = '';
      }
   }
}

document.addEventListener("DOMContentLoaded", () => {
   const containers = document.querySelectorAll('.sn33-rdv-container');
   for(const container of containers) {
      new Sn33Rdv(parseInt(container.id.split('-')[3]));
   }
});
